const SCORE = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
};

const RUBRIC = {
    LITERAL: 'LITERAL_TYPE',
    INFERENCE: 'INFERENTIAL_TYPE',
    CRITICAL: 'CRITICAL_TYPE',
    CREATIVE: 'CREATIVE_TYPE',
};

const rubricMapper = {
    [RUBRIC.LITERAL]: {
        description: 'Literal: Characters, settings, problems, plot details',
        items: [
            "Can't identify main idea, ideas inaccurate, even with prompting",
            'Needs prompting, limited sense of main idea, some inaccuracies',
            'Adequately explains main idea, but lacks detail unless prompted',
            'Full grasp of main idea with no prompting required',
        ],
    },
    [RUBRIC.INFERENCE]: {
        description: 'Inference: Connects details of story, grasps implicit meaning',
        items: [
            'Does not describe any details',
            'Requires prompting to produce a few supporting details',
            'Adequate detail without prompting, connects details to main idea',
            'Grasps details and how they are connected',
        ],
    },
    [RUBRIC.CRITICAL]: {
        description: 'Critical: Evaluates story information and meaning',
        items: [
            'No opinions, inferences or insights',
            'When prompted expresses opinions and makes inferences',
            'Has opinions and can express response to the book',
            'Thoroughly responsive to and opinionated about the book',
        ],
    },
    [RUBRIC.CREATIVE]: {
        description: 'Creative: Imagination sparked by story',
        items: [
            'Does not connect the book to anything else',
            'With prompting can make loose connections beyond book',
            'Connects the book to own life, considers related ideas',
            'Makes connections to own life, prior knowledge, new questions',
        ],
    },
};

const wcScoreList = [
    { score: SCORE.ZERO, text: 'No Understanding' },
    { score: SCORE.ONE, text: 'Minimal Understanding' },
    { score: SCORE.TWO, text: 'General Understanding' },
    { score: SCORE.THREE, text: 'Complex Understanding' },
];

const retellRecallValues = {
    retellValues: [
        {
            score: SCORE.THREE,
            text: 'Student provides the beginning, middle, and end sections in a meaningful order.',
        },
        {
            score: SCORE.TWO,
            text: 'Student provides two sections in a meaningful order OR three sections out of order.',
        },
        {
            score: SCORE.ONE,
            text: 'Student provides one section OR two sections out of order.',
        },
        { score: SCORE.ZERO, text: 'Student does not retell any part of the story.' },
    ],
    recallValues: [
        {
            score: SCORE.THREE,
            text: 'Student provides the main idea and two or more key details.',
        },
        { score: SCORE.TWO, text: 'Student provides the main idea and one key detail.' },
        {
            score: SCORE.ONE,
            text: 'Student provides two or more key details without the main idea.',
        },
        {
            score: SCORE.ZERO,
            text: 'Student provides only the main idea OR one key detail, OR student recalls nothing from the text.',
        },
    ],
    fictionValues: [
        { score: SCORE.ZERO, text: '0-1 detail' },
        {
            score: SCORE.ONE,
            text: '2 or more details, not sequentially told',
        },
        {
            score: SCORE.TWO,
            text: '2-3 details, sequentially told',
        },
        {
            score: SCORE.THREE,
            text: 'A full retelling of 4 or more details, sequentially told',
        },
    ],
    nonFictionValues: [
        { score: SCORE.ZERO, text: 'No facts' },
        { score: SCORE.ONE, text: '1 fact' },
        { score: SCORE.TWO, text: '2 facts in any order' },
        { score: SCORE.THREE, text: '3 or more facts in any order' },
    ],
};

const COMPREHENSION_VALUES = {
    rubricMapper,
    wcScoreList,
    retellRecallValues,
};

export default COMPREHENSION_VALUES;
